module.exports = "../study/imgs/maps/Tokyo/S8/Agriculture/RiceQ/Tokyo_RiceQ_GFDL_RCP45_Mid.png";